import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

const API_BASE_URL = "https://api.ui.com/v1/mobility";

export const unifiMobility = defineConnector({
  identifier: "unifiMobility",
  name: "UniFi Mobility",
  tagLine: "Management for UniFi mobile routing products",
  keywords: "ubiquiti mobile router workspaces",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => exactUrlToRegex(API_BASE_URL),
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a UniFi Mobility API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [UniFi Mobility](https://mobility.ui.com/api-keys), create an API key with `mobility` and `read:mobility` access.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: `${API_BASE_URL}/workspaces`,
      method: "GET",
      headers: { Accept: "application/json" },
    }),
  },
});
